const styles = {
  root: {
    background: "#fff",
    borderRadius: "0.5rem",
    color: "rgba(0, 0, 0, 0.8)",
    fontSize: "0.9rem",
    overflow: "hidden",
    padding: "0.2rem",
    position: "relative",
  },
  item: {
    background: "transparent",
    border: "1px solid transparent",
    borderRadius: "0.4rem",
    display: "block",
    margin: 0,
    padding: "0.2rem 0.4rem",
    textAlign: "left",
    width: "100%",
  },
  isSelected: {
    borderColor: "#000",
  },
  mergeTagContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "7px",
    px: "12px",
    py: "7px",
    backgroundColor: "yellow.light",
    border: "1px solid",
    borderColor: "purple.light",
    borderRadius: "16px",
  },
  label: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "secondary.dark",
    whiteSpace: "nowrap",
  },
  labelIcon: {
    fontSize: "13px",
    color: "purple.dark",
  },
  mergeTag: {
    backgroundColor: "#fff",
    border: "1px solid",
    borderColor: "purple.main",
    color: "purple.dark",
    borderRadius: "999px",
    padding: "2px 9px",
    fontSize: "11.5px",
    fontFamily:
      '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace',
    cursor: "pointer",
    whiteSpace: "nowrap",
    userSelect: "none",
    transition: "background-color 0.12s",
    "&:hover": { backgroundColor: "purple.light" },
    "&:active": { backgroundColor: "purple.main", color: "#fff" },
  },
  hint: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    ml: "auto",
    fontSize: "11px",
    color: "grey.500",
    whiteSpace: "nowrap",
  },
  hintIcon: {
    fontSize: "12px",
  },
};

export default styles;
